import { render, staticRenderFns } from "./section-block-shell.vue?vue&type=template&id=3f300945&"
import script from "./section-block-shell.vue?vue&type=script&lang=js&"
export * from "./section-block-shell.vue?vue&type=script&lang=js&"
import style0 from "./section-block-shell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports